import { EnvironmentProviders, Provider } from '@angular/core';
import {
  HttpInterceptorFn,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { API_BASE_URL } from './api-base-url.token';
import { httpErrorInterceptor } from './http-error.interceptor';
import { resolveApiBaseUrl } from './resolve-api-base-url';
import { traceContextInterceptor } from './trace-context.interceptor';

export const provideCoreHttp = (
  apiBaseUrl?: string | (() => string),
  interceptors: HttpInterceptorFn[] = [],
): (Provider | EnvironmentProviders)[] => [
  {
    provide: API_BASE_URL,
    useFactory: () => resolveApiBaseUrl(apiBaseUrl),
  },
  provideHttpClient(withInterceptors([traceContextInterceptor, httpErrorInterceptor, ...interceptors])),
];
